import { TimeZoneDTO } from "../DTO/timeZoneDTO";

export class TimeZone{
    public timeZoneId!: string;
    public timeZoneName!: string;

    public static mapFromDTO(param:TimeZoneDTO):TimeZone{
        if(!param) throw new Error("parameter is null")
        let obj = new TimeZone();
        try
        {
            obj.timeZoneId = param.timeZoneId;
            obj.timeZoneName = param.timeZoneName;
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    public static mapToDTO(param:TimeZone):TimeZoneDTO{
        if(!param) throw new Error("parameter is null")
        let dto = new TimeZoneDTO();
        try
        {
            dto.timeZoneId = param.timeZoneId;
            dto.timeZoneName = param.timeZoneName;
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }

    get displayTimeZoneName(){
        return this.timeZoneId?this.timeZoneId:this.timeZoneName;
    }
}

